import { graphql, useStaticQuery } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Link, useI18next } from "gatsby-plugin-react-i18next";
import { isDMM } from "libs/dmm";
import * as React from "react";

const Query = graphql`
    query Copyright {
        terms: markdownRemark(
            frontmatter: {
                type: { eq: "announcement" }
                slug: { eq: "darkwind-service-terms" }
            }
        ) {
            frontmatter {
                slug
            }
        }
        policy: markdownRemark(
            frontmatter: {
                type: { eq: "announcement" }
                slug: { eq: "darkwind-policy" }
            }
        ) {
            frontmatter {
                slug
            }
        }
        announce: markdownRemark(
            frontmatter: {
                type: { eq: "announcement" }
                slug: { eq: "darkwind-announce" }
            }
        ) {
            frontmatter {
                slug
            }
        }
        guidelines: markdownRemark(
            frontmatter: {
                type: { eq: "announcement" }
                slug: { eq: "darkwind-guidelines" }
            }
        ) {
            frontmatter {
                slug
            }
        }
    }
`;

export function Copyright() {
    const { language, t } = useI18next();
    const data = useStaticQuery<Queries.CopyrightQuery>(Query);
    // noinspection AllyJsxHardcodedStringInspection
    return (
        <section className="py-8 lg:py-12 text-xs text-primary bg-black/30">
            <div className="container mx-auto px-4">
                {/* 主要內容區 - 垂直排列 */}
                <div className="flex flex-col items-center gap-4 lg:gap-6 mb-6">
                    {/* Logo 區域 + 18+ - 置中 */}
                    <div className="flex items-center gap-4 lg:gap-6 justify-center">
                        <div className="w-16 lg:w-20">
                            <StaticImage
                                src="../images/pinkcore-logo@2x.png"
                                alt="PINKCORE"
                            />
                        </div>
                        <div className="w-24 lg:w-32">
                            <StaticImage
                                src="../images/logo-tss@2x.png"
                                alt="THE SHADOW STUDIO"
                            />
                        </div>
                        
                        {/* 18+ 標誌 */}
                        <div className="w-12 h-12 lg:w-16 lg:h-16">
                            <StaticImage
                                src="../images/18.png"
                                alt="18+ 限制級"
                            />
                        </div>
                    </div>

                    {/* 鏈接區域 - 置中 */}
                    <div className="text-center">
                        <p>
                            {isDMM ? (
                                <>
                                    <Link to={"/news/" + data.policy?.frontmatter?.slug} className="lg:hover:text-white">
                                        Privacy Policy
                                    </Link>
                                    {" | "}
                                    <Link to={"/news/" + data.terms?.frontmatter?.slug} className="lg:hover:text-white">
                                        Terms of Use
                                    </Link>
                                </>
                            ) : (
                                <a
                                    href={t("policy_link")}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="lg:hover:text-white"
                                >
                                    Privacy Policy | Terms of Use
                                </a>
                            )}
                            {" | "}
                            <a
                                href={`https://support.pinkcore.com/?lang=${language}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="lg:hover:text-white"
                            >
                                Contact Us
                            </a>
                        </p>
                        {isDMM && (
                            <p className="mt-1">
                                <Link to={"/news/" + data.announce?.frontmatter?.slug} className="lg:hover:text-white">
                                    特定商取引法に基づく表示
                                </Link>
                                {" | "}
                                <Link to={"/news/" + data.guidelines?.frontmatter?.slug} className="lg:hover:text-white">
                                    二次創作ルール
                                </Link>
                            </p>
                        )}
                    </div>
                </div>

                {/* 警告文字 - 僅台灣地區顯示 */}
                {language === "zh-tw" && (
                    <div className="text-center mb-4 text-[10px] lg:text-xs leading-relaxed">
                        本遊戲分類為限制級，須滿18歲始得購買或使用。請注意遊戲時間，避免沉迷。遊戲虛擬情節請勿模仿。<br className="hidden lg:block" />
                        本遊戲為免費使用，但遊戲部分內容或服務需另行支付其他費用，請依個人興趣、能力進行購買，請勿過度消費。<br className="hidden lg:block" />
                        請閱讀、瞭解並同意「使用者服務條款」及「個人資料暨隱私政策條款」之所有內容後，方得使用本遊戲服務。
                    </div>
                )}

                {/* 版權信息 */}
                <p className="text-center text-[10px] lg:text-xs">
                    ©2022-2026 The Shadow Studio / Rise of Eros™
                </p>
            </div>
        </section>
    );
}
